<template>
<div>
    <Header />
        <Spin size="large" fix v-if="spinShow"></Spin>

    <div id='LoginForm'>
        <div class="container">

            <h1 class="form-heading text-center" style="margin-top:79px;">{{$t('signuptitle')}}</h1>
            <div class="login-form" style="margin-top:32px;">
                <div class="main-div">

                    <div id="Login">
                        <div class="alert alert-danger" v-if="alertDanger != ''" role="alert">{{alertDanger}}</div>
                        <div class="alert alert-success" v-if="alertSuccess != ''" role="alert">{{alertSuccess}}</div>

                        <div class="form-group">

                            <label for="inputEmail" class='green float-left margin-bottom-15'>{{$t('email')}}</label>

                            <input type="email" v-bind:readonly="isReadOnly" v-model="email" class="form-control width-320 height-40  border-green" id="inputEmail" placeholder="Email Address">
                        </div>

                        <div class="form-group">
                            <label for="inputPassword" class='green float-left margin-bottom-15'>{{$t('password')}}</label>
                                <input type="password" name="txtPassword" style="display:none">

                            <input type="password" @keyup.enter="login" v-model="password" class="form-control width-320 height-40 margin-bottom-15 border-green" id="inputPassword" placeholder="Password">

                        </div>

                        <button @click="login" class="bg-green btn btn-primary margin-top-24 margin-bottom-24  width-320">{{$t('login')}}</button>
                        <!-- <div class="forgot">
                            <a href="reset.html?reset=2">{{$t('forgetpw')}}</a>
                            <a href="/Reg" style="" class="float-right">{{$t('signup')}}</a>
                        </div> -->

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import settings from '@/utils/settings';
import 'bootstrap';
var md5 = require('md5');
import $ from 'jquery'
import Utils from '@/utils/Utils';
import axios from '@/service/interceptor';
import * as types from '@/store/mutation-types';
import Header from '@/components/common/Header.vue';

//import $ from "jquery";
export default {
    components: {
        Header,
    },
    data() {
        return {
            spinShow: false,
            isReadOnly: false,
            lang: Utils.getQueryObject().lang || localStorage.getItem("lang") || 'tr',
            langVal: Utils.getLangVal(Utils.getQueryObject().lang || localStorage.getItem('lang') || 'tr'),
            email:  '',
            token: Utils.getQueryObject().token || '',
            password: '',
            rePassword: '',
            alertDanger: '',
            alertSuccess: '',
            arrayOfObjects: ['English', '中文'],
            object: {
                name: 'English',
            }
        }
    },
    mounted() {
        // $('.dropdown-toggle').dropdown()
        this.email = Utils.getToken(this.token).email;
        this.isReadOnly = this.email
    },

    methods: {
        switchLanguage(lang) {
            // if (lang === this.lang) return false
            location.href = Utils.changeURLArg(location.href, 'lang', lang)
        },
        methodToRunOnSelect(payload) {
            this.object = payload;
        },
        login() {
            var self = this
            self.alertDanger = ''
            self.alertSuccess = ''
            self.spinShow= true;
            axios.post(`${settings.HOST}/api/v1`, {
                cmd: "login",
                email: self.email,
                loginPwd: md5(self.password+settings.salt),
            }).then(function (data) {
                self.spinShow= false;

                if (data.data.code === 100002) {
                    return self.alertDanger = self.$t('loginWrong')
                }
                if (data.data.code === 0) {
                    // if (data.data.userStatus === '0') {
                        const userToken = {
                            email: self.email,
                            token: data.data.userToken,
                            bttUserid: data.data.bttUserid,
                        }
                        self.$store.commit(types.LOGIN, userToken);
                        localStorage.setItem('session', JSON.stringify(userToken))
                        
                        self.$router.push(`/Balance?token=${self.token}`)
                    // } else {
                    //     self.alertSuccess = 'Please check your active email to active'
                    // }
                } else {
                    self.alertDanger = 'Error'
                }
            })
        }
    }
}
</script>
<style scoped>
@import 'bootstrap/dist/css/bootstrap.css';
@import '../../static/style/lib.css';
@import '../../static/style/reg.css';
</style>



// WEBPACK FOOTER //
// src/views/Login.vue